import { c as _c } from "react/compiler-runtime";
import { twMerge } from 'tailwind-merge';
type Props = {} & React.ComponentPropsWithoutRef<'span'>;
export function Bullet(t0) {
  const $ = _c(4);
  const {
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = twMerge("text-zinc-400 dark:text-zinc-600", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== t1) {
    t2 = <span className={t1} aria-hidden="true">•</span>;
    $[2] = t1;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  return t2;
}